export default {
  customize: {
    orders: '订单',
    customers: '顾客',
    setting: '个人中心',
    shopName: '店铺名字',
    username: '登录用户',
    logout: '用户登出',

    // order list
    orderList: '订单列表',
    allOrders: '全部订单',
    unpaid: '未付款',
    partialyPaid: '部分付款',
    paid: '已付款',
    picking: '配货中',
    shipped: '已发货',
    completed: '交易完成',
    requestRefund: '申请退款',
    refundFinished: '退款完成',
    closed: '已关闭',
    未付款: '未付款',
    部分付款: '部分付款',
    '已付款（待发货）': '已付款（待发货）',
    配货中: '配货中',
    '已发货（待完成）': '已发货（待完成）',
    '未付款已发货（待完成）': '未付款已发货（待完成）',
    交易完成: '交易完成',
    申请退款: '申请退款',
    退款完成: '退款完成',
    用户取消订单后关闭: '用户取消订单后关闭',
    退款完成后关闭: '退款完成后关闭',
    管理员关闭订单并退款: '管理员关闭订单并退款',
    管理员关闭订单: '管理员关闭订单',
    支付超时关闭订单: '支付超时关闭订单',
    已关闭: '已关闭',
    pickUp: '到店自取',
    wechatName: '微信昵称：',
    phone: '电话号码：',
    goodsValue: '商品价格：',
    shippingFee: '运费：',
    totalFee: '总价：',
    unbound: '未绑定',

    // order details
    undefined: '',
    orderDetails: '订单详情',
    addExpressNo: '添加快递单号',
    uploadImg: '上传订单图片',
    checkOrder: '订单校验',
    orderOperation: '附件操作',
    statusOperation: '状态操作',
    toCustomer: '给顾客留言',
    goodsList: '商品列表',
    expressInfo: '快递信息',
    orderAttachment: '订单附件',
    operationLog: '操作日志',
    updateOrder: '更新订单',
    orderStatus: '订单状态',
    orderValue: '订单价格',
    others: '其他操作',
    new: '最新',
    confirmUpdateOrder: '确定更新该订单？',
    confirm: '确认',
    cancel: '取消',
    updateSuccess: '订单更新成功',
    updateFail: '订单更新失败',
    loading: '加载中...',
    createAt: '下单时间：',
    none: '无',
    goodsValueBeforeDiscount: '商品折扣前金额',
    expressFeeBeforeDiscount: '运费折扣前金额',
    goodsFeeAfter: '商品折扣后金额',
    expressFeeAfter: '运费折扣后金额',
    finalFee: '订单最终总金额',
    consignee: '收货人：',
    idCardNo: '身份证号：',
    address: '地址：',
    consigner: '发货人：',
    paidAt: '支付时间',
    shippingAt: '发货时间',
    finishedAt: '完成时间',
    expressCompany: '快递公司',
    expressNoPlaceHolder: '如输入多个订单号, 请以英文逗号“,”分隔',
    scanExpressCode: '扫描快递单',
    clickUpload: '点击上传图片',
    confirmDeleteImage: '确认删除图片',
    deletingImg: '删除图片中...',
    deleteImgSuccess: '图片删除成功',
    deleteImgFail: '图片删除失败',
    uploadImgFail: '上传图片失败，请重试。',
    saveImgSuccess: '订单图片保存成功',
    saveImgFail: '订单图片保存失败',
    uploadingImg: '上传图片中...',
    uploadQiniuFail: '图片上传七牛失败',
    getTokenFail: '七牛token获取失败',
    cancelRefund: '取消退款',
    refundToCredit: '退款到余额',
    operationNotes: '操作备注',
    pleaseInput: '请输入内容',
    leaveMessage: '给顾客留言',
    barCode: '条形码: ',
    bestBefore: '保质期: ',
    noExpressInfo: '暂无快递信息',
    operator: '操作者：',
    operationType: '操作属性：',
    operationTime: '操作时间：',
    scanBarCode: '扫描商品条形码',
    submit: '提交',
    finishCheck: '此商品已完成检货!',
    noMatchGoods: '没有匹配到商品!',
    checkSuccess: '订单校验成功!',
    checkFail: '订单校验失败!',
    customerMessage: '顾客留言',
    originalGoodsFee: '商品原价',
    originalShippingFee: '运费原价',
    discountedGoodsFee: '商品折扣后金额',
    discountedShippingFee: '运费折扣后金额',
    orderShopPrice: '采购订单金额',
    orderFinalPrice: '订单支付总金额',
    agentProfit: '分销利润',
    orderActivity: '订单参与的运营活动',
    orderCoupon: '订单使用的优惠券',
    promotionActivity: '（运营活动）',
    couponActivity: '（优惠券）',
    writeOffButton: '已提货并完成订单',
    writeOffTitle: '订单商品已提货',
    writeOffSuccessfully: '核销成功',
    writeOffFailed: '核销失败',
    refundType: '退款方式',
    refundToOPM: '原路退回',
    refundToOffline: '线下操作退款',
    MyPayAccountBalanceNotEnough: '商户MyPAY账户余额不足，退款失败',
    poliPayRefundOperation: '该笔订单中有POLi支付的部分，请线下转账退给用户: ',

    // customer
    customerList: '顾客列表',
    level: '会员等级',
    points: '会员积分',
    expense: '消费金额',
    credit: '账户余额',
    registrationDate: '注册时间',
    customerDetails: '顾客详情',
    customerRemark: '会员备注',
    editLevel: '会员等级修改',
    edit: '修改',
    editCustomerRemark: '会员备注修改',
    updateRemarkSuccess: '会员备注更改成功',
    updateRemarkFail: '会员备注更改失败',
    updateLevelSuccess: '会员等级更新成功',
    updateLevelFail: '会员等级更新失败',
    accountCredit: '账户余额',
    nowCredit: '账户现有余额',
    editCredit: '账户余额修改',
    inputCredit: '请输入金额',
    creditAmount: '操作金额：',
    operationDetails: '操作详情：',
    线上充值余额: '线上充值余额',
    商家操作增加余额: '商家操作增加余额',
    退款余额: '退款余额',
    购买商品使用余额: '购买商品使用余额',
    商家操作减少余额: '商家操作减少余额',
    其他操作: '其他操作',
    updateCreditSuccess: '余额操作更改成功',
    updateCreditFail: '余额操作更改失败',
    comment: '备注：',

    // search
    orderSearch: '订单搜索',
    goBack: '返回',
    search: '搜索',
    searchPlaceHolder: '订单号，快递单号，账号，微信昵称，收货人，发货人',
    customerSearch: '顾客搜索',
    customerPlaceHolder: '请输入电话号码或者微信昵称',

    orderWriteOff: '订单核销',
    writeOffCode: '核销码'
  }
}
